module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Attendance-Leaves/time-roll-finalization/time-roll-fin-grid/time-roll-fin-grid.component.css
// module id = ./src/app/hrms/Attendance-Leaves/time-roll-finalization/time-roll-fin-grid/time-roll-fin-grid.component.css
// module chunks = main